<div>
  <div *ngIf="!successfullyUnsubscribed" class="unsubscribe">
    <div style="margin-bottom: 32px;">
      <img src="../../assets/unsubscribe-email.png" alt="Unsubscribe">
    </div>
    <div class="f-24 font-weight-600 text-484b59" style="margin-bottom: 12px;">
      Do you want to Unsubscribe?
    </div>
    <div class="f-16 text-484b59 text-center" style="margin-bottom: 32px;">
      Click on Unsubscribe to stop receiving from {{email}}
    </div>
    <div class="">
      <button data-testid="auto-app-unsubscribe-button-1" class="btn-trms-small" (click)="onClickUnsubscribe()">
        Unsubscribe
      </button>
    </div>
  </div>
  <div *ngIf="successfullyUnsubscribed" class="unsubscribe" style="padding: 65px 80px 65px 80px;">
    <div style="margin-bottom: 32px;" *ngIf="!unauthorized">
      <img src="../../assets/unsubscribe-email-success.png" alt="Unsubscribe">
    </div>
    <div style="margin-bottom: 32px;" *ngIf="unauthorized">
      <img src="../../assets/something-went-wrong.png" alt="Unsubscribe">
    </div>
    <div class="f-24 font-weight-600 text-484b59">
      {{afterUnsubscribeText}}
    </div>
  </div>
</div>